enum ReactAppEnvironment {
  Local = 'local',
  Test1 = 'test1',
  Test2 = 'test2',
  Staging = 'staging',
  Cloud = 'cloud',
}

export default ReactAppEnvironment;
